/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_TimeInputs */

const en_wb_support_time = /** @type {(inputs: Wb_Support_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`09:12`)
};

const lv_wb_support_time = /** @type {(inputs: Wb_Support_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`09:12`)
};

/**
* | output |
* | --- |
* | "09:12" |
*
* @param {Wb_Support_TimeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_time = /** @type {((inputs?: Wb_Support_TimeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_TimeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_time(inputs)
	return en_wb_support_time(inputs)
});